module.exports = __webpack_public_path__ + "static/homepage-dots-ed4dc036fa97103c8ddd04ab9d5a905e.png";